import { checkDuplicateVideoWithLanguage } from '../../../utils';
import { ERROR_TYPES } from '../../../components/Modal/ErrorModal';
import { AI_API_URL } from '../../../constants';

export const useDuplicateChecker = () => {
  // 개인 히스토리 중복 체크 (로컬)
  const checkLocalDuplicate = (extractedVideoId, language, history, showErrorModal, setInputUrl, setInputTitle) => {
    const existingHistory = checkDuplicateVideoWithLanguage(extractedVideoId, language, history);
    if (existingHistory) {
      const historyTitle = existingHistory.customTitle || existingHistory.title;
      
      // 6개 언어 지원 - 언어별 표시명 매핑
      const languageNames = {
        'ko': '한국어',
        'en': 'English', 
        'zh': '中文',
        'ja': '日本語',
        'es': 'Español',
        'fr': 'Français'
      };
      const languageName = languageNames[language] || existingHistory.languageName || '해당 언어';
      
      console.log(`✅ [개인 히스토리] 이미 존재: ${extractedVideoId} (${language})`);
      
      showErrorModal(
        ERROR_TYPES.DUPLICATE_VIDEO, 
        `"${historyTitle}" 영상은 ${languageName}로 이미 분석되었습니다.`,
        null,
        existingHistory.id
      );
      
      // 입력 필드 초기화
      setInputUrl("");
      setInputTitle("");
      return true;
    }
    return false;
  };

  // 개인 히스토리 중복 체크 (API)
  const checkPersonalHistory = async (extractedVideoId, language, userId, showErrorModal, setInputUrl, setInputTitle) => {
    try {
      console.log(`🔍 [개인 히스토리] ${extractedVideoId} (${language}) 검색 중...`);
      
      const personalCheckResponse = await fetch(`${AI_API_URL}/api/streaming/check-personal-history/${extractedVideoId}?language=${language}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'user-id': userId
        }
      });
      
      if (personalCheckResponse.ok) {
        const personalCheckResult = await personalCheckResponse.json();
        
        if (personalCheckResult.exists) {
          console.log(`✅ [개인 히스토리] 기존 히스토리 발견! ID: ${personalCheckResult.historyId}`);
          
          const historyTitle = personalCheckResult.title || personalCheckResult.customTitle || "";
          
          // 6개 언어 지원 - 언어별 표시명 매핑
          const languageNames = {
            'ko': '한국어',
            'en': 'English', 
            'zh': '中문',
            'ja': '日本語',
            'es': 'Español',
            'fr': 'Français'
          };
          const languageName = languageNames[language] || '해당 언어';
          
          showErrorModal(
            ERROR_TYPES.DUPLICATE_VIDEO, 
            `"${historyTitle}" 영상은 ${languageName}로 이미 분석되었습니다.`,
            null,
            personalCheckResult.historyId
          );
          
          // 입력 필드 초기화
          setInputUrl("");
          setInputTitle("");
          
          return true;
        } else {
          console.log(`❌ [개인 히스토리] 없음, 광역 히스토리 체크 진행`);
          return false;
        }
      } else {
        const errorText = await personalCheckResponse.text();
        console.warn(`⚠️ [개인 히스토리] API 에러:`, personalCheckResponse.status, errorText);
        return false;
      }
    } catch (error) {
      console.warn(`⚠️ [개인 히스토리] 네트워크 에러:`, error.message);
      return false;
    }
  };

  // 광역 히스토리 중복 체크
  const checkGlobalHistory = async (extractedVideoId, language, userId) => {
    try {
      console.log(`🔍 [광역 히스토리] ${extractedVideoId} (${language}) 검색 중...`);
      
      const globalCheckResponse = await fetch(`${AI_API_URL}/api/streaming/check-global-history/${extractedVideoId}?language=${language}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'user-id': userId
        }
      });
      
      if (globalCheckResponse.ok) {
        const globalCheckResult = await globalCheckResponse.json();
        
        if (globalCheckResult.exists) {
          console.log(`✅ [광역 히스토리] 발견! 개인 히스토리로 복사 시작...`);
          return true;
        } else {
          console.log(`❌ [광역 히스토리] 없음, 새로 분석 진행`);
          return false;
        }
      } else {
        const errorText = await globalCheckResponse.text();
        console.warn(`⚠️ [광역 히스토리] API 에러:`, globalCheckResponse.status, errorText);
        return false;
      }
    } catch (error) {
      console.warn(`⚠️ [광역 히스토리] 네트워크 에러:`, error.message);
      return false;
    }
  };

  return {
    checkLocalDuplicate,
    checkPersonalHistory,
    checkGlobalHistory
  };
}; 